<script setup lang="ts">
const { homeUrl, lang } = site;
const logoUrl = `/wp-content/themes/egalite/src/assets/images/logo-${lang}.png`;
</script>

<template>
  <a :href="homeUrl" class="block">
    <img :src="logoUrl" :alt="__('Teaching equality', 'egalite')" class="h-12 w-auto">
  </a>
</template>
